module.exports = __webpack_public_path__ + "static/media/pool-hall13.d2e7b982.jpg";